export function range(min: number, max: number): number[] {
	const numbers: number[] = [];
	for (let number = min; number <= max; number++) {
		numbers.push(number);
	}
	return numbers;
}
